<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  /* padding: 20px; */
  overflow-y: scroll;
}

.margin{
  color: white;
  margin-top: 50px;
  text-align: center;
}

.card{
  background-color: rgba(0,0,0,0.4);
  color: white;
  border-radius: 20px;
  margin: 10px auto 50px auto;
  padding: 1px 1px 20px 1px;
  width: 350px;
  box-shadow: 0 0 5px #555;
}
.question{
  margin: 28px;
}
.slider{
  padding: 0 20px;
}

.text{
  display: grid;
  grid-template-columns: 16px auto auto 16px;
  font-size: 16px;
  margin: 5px;
}
.left-arrow{
  grid-column: 1;
}
.left-text{
  grid-column: 2;
}
.right-text{
  grid-column: 3;
  text-align: right;
}
.right-arrow{
  grid-column: 4;
}
.buttons{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  background-color: black;
}
.has-buttons{
  height: 120px;
}

.title-signup{
  margin-top: 20px;
}

</style>

<div class="bg">
  <div class="title-signup">Match Questions ({Questions.length})</div>
  
  {#each Questions as item}
  
    {#if item.type == 'scale0-5'}
    
      {#if showAllHelper(item)}
      
      <div class="card">
        
        <div class="question">Q: {item.question}</div>
        <div class="question">A: { item.selected[0] != 0 ? item.answers[ item.selected[0] - 1 ] : 'No Answer' }</div>
        
        <div class="slider">
          <RangeSlider id="matchQuestion1" min="{0}" max="{5}" pips bind:values="{item.selected}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
        </div>
        
        <div class="text">
          <div class="left-arrow"><i class="icon-arrow_left"></i></div>
          <div class="left-text">{item.leftText}</div>
          <div class="right-text">{item.rightText}</div>
          <div class="right-arrow"><i class="icon-arrow_right"></i></div>
        </div>
        
      </div>
      
      {/if}
    
    {/if}
  
  {/each}

  <div class="has-buttons"></div>
</div>


<!-- <div class="buttons">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<div class="buttons">
  <NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import RangeSlider from "svelte-range-slider-pips";
import NextButton from "../../../../components/NextButton.svelte";

import Questions from "../../../../helpers/Questions.js";
import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("questionsSaved", false);
  // Signup.saveToPersonalObject("questions", []);
  questionsSaved = Signup.getPersonalObject("questionsSaved");
  let questions = Signup.getPersonalObject("questions");
  
  // if questions length is zero, we need to create an "empty" array that 
  // contains all zeros.  this is because if we don't, 
  // all the answers to the questions will be "undefined"
  
  // associate localStorage with Questions
  for (let i in Questions) {
    if (Questions[i].default == true) {
      if (Questions[i].i in questions) {
        Questions[i].selected[0] = questions[Questions[i].i];
      } else {
        // we don't know how many default questions there are
        // so, we build an array based on how many default questions.  this could change,
        // so we don't define a static array
        Questions[i].selected[0] = 0;
      }
    }
  }
  
  if (questionsSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let questionsSaved = false;
let nextDisabled = true;


function showAllHelper(item) {
  if (item.default == true) {
    return true;
  }
  
  return false;
}


function check() {
  questionsSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  
  if (questionsSaved == false) {
    // pull question ids and answers from Questions and add them to a local array
    // for sharing and storing
    
    // questions are stored based on their Questions.i aka it's id number.
    // these are stored in a simple array using a question scale number.
    // so if question.id = 3 and the user selected 4, then [3:4], 
    // aka [..., ..., ..., 4, ..., ...]
    let questions = [];
    
    for (let i in Questions) {
      if (Questions[i].default == true) {
        questions[Questions[i].i] = Questions[i].selected[0];
      }
    }
    
    // console.log("questions:", questions);
    
    await Signup.saveToPersonalObject("questions", questions);
    await Signup.saveToPersonalObject("questionsSaved", true);
    await Signup.saveMe("questions");
  }
  
  push("/signup/profile/personal/bio");
}



</script>